import { Button, Typography } from '@mui/material';
import { KrDialog } from '../dialog/Dialog';

export const ApprNoteDialog = ({ data, closeDialog }) => {
  return (
    <KrDialog
      title={data.title}
      subtitle={data.subtitle}
      closeDialog={() => closeDialog()}
      maxWidth="sm"
      buttons={[<Button onClick={() => closeDialog()}>Close</Button>]}
    >
      <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
        {data.note}
      </Typography>
    </KrDialog>
  );
};
